module.exports = __webpack_public_path__ + "images/Christine_Vandevoorde.jpg?v=42a2c607ec673a43035100f22d11455e";